import { motion } from 'framer-motion';
import { forwardRef } from 'react';
import { ClassNames } from '../../../interfaces';
import { classes } from '../../../utils/commonUtils';
import css from './backdrop.module.scss';

const variants = {
  hidden: {
    opacity: 0,
  },
  visible: {
    opacity: 0.85,
    transition: {
      duration: 0.2,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
    },
  },
};

interface BackdropProps {
  children: React.ReactNode;
  classNames?: ClassNames<'container' | 'backdrop'>;
  onClick?: () => void;
}

export const Backdrop = forwardRef<HTMLDivElement, BackdropProps>(({ children, classNames, onClick }, ref) => {
  return (
    <div className={classes(css.container, classNames?.container)} ref={ref}>
      <motion.div
        onClick={onClick}
        className={classes(css.backdrop, classNames?.backdrop)}
        variants={variants}
        initial="hidden"
        animate="visible"
        exit="exit"
      />
      {children}
    </div>
  );
});
